
  import { css } from 'lit';
  export const styles = css`:host{--disabled-color: var(--ig-label-disabled-color, var(--ig-gray-400));--ig-theme: bootstrap;--ig-theme-variant: light}`;
  